module.exports = __webpack_public_path__ + "@/assets/img/cursado-materias.0af2a06f.svg";